import styled from 'styled-components';

export const StyledSpan = styled.span`
  color: ${({ theme }): string => {
    return theme.palette_gray_60;
  }};
`;
